// Central configuration for report date-window defaults.
//
// The StartEndDate filter normally defaults to "Since Start" (a very large day
// count). Some reports should instead default to a short, recent window. Keep
// that list here so it only has to be maintained in one place.

// Day count representing the "Since Start" preset.
export const SINCE_START_DAYS = 7000;

// Reports whose StartEndDate filter should default to a shorter window
// instead of "Since Start", keyed by report ID. Values must match a preset's day count.
export const REPORT_DEFAULT_DAYS: Record<number, number> = {
    62: 90,
    63: 7
};

/**
 * Returns the default number of days for a report's StartEndDate window.
 * Reports listed in REPORT_DEFAULT_DAYS use their configured window; all
 * others default to "Since Start".
 */
export const getStartEndDateDefaultDays = (reportId: number): number => REPORT_DEFAULT_DAYS[reportId] ?? SINCE_START_DAYS;
